import { render, staticRenderFns } from "./EditJourney.vue?vue&type=template&id=3df85706"
import script from "./EditJourney.vue?vue&type=script&lang=js"
export * from "./EditJourney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports